import { RANGES } from '../filters-model'
import { daysBetween, dayOf, UTC } from '../../date/local-time'

// The zone a response counted its hours and days in (content names it,
// timeZone: the reader's tz=); UTC from a server that doesn't say.
export const countedZone = data => (data && data.timeZone) || UTC

// The days of a calendar response, in order: every day (in the zone it was
// counted in) from the window's first to its last (a day with no entries
// counts 0), as the Insights calendar and the calendar strip both draw them.
export const calendarDays = data => {
  if (!data || !data.from || !data.to) return []
  const byDay = new Map((data.days || []).map(d => [d.day, d]))
  return daysBetween(data.from, data.to, countedZone(data)).map(day => {
    const d = byDay.get(day) || {}
    return { day, total: d.total || 0, changes: d.changes || 0, signIns: d.signIns || 0, views: d.views || 0, launches: d.launches || 0 }
  })
}
// Monday = 0 (ISO weekdays, as the calendar's rows). A day is a calendar
// date, the same in every zone.
export const weekdayOf = day => (new Date(`${day}T00:00:00Z`).getUTCDay() + 6) % 7

// The page's period (its time filter: a preset, a custom range or one
// day) as the days of the calendar it covers (in the calendar's zone, tz),
// and its name; null when it covers no day, or the whole calendar (nothing
// to single out).
export const periodDays = (params, days, tz = UTC) => {
  if (!params || !params.from || !days.length) return null
  const from = Date.parse(params.from)
  const to = params.to ? Date.parse(params.to) : Date.now()
  if (!(from < to)) return null
  const a = dayOf(from, tz)
  // an exclusive midnight end ends the day before
  const b = dayOf(to - 1, tz)
  const inside = days.filter(d => d.day >= a && d.day <= b).map(d => d.day)
  if (!inside.length || inside.length === days.length) return null
  const range = RANGES.find(r => r.ms && Math.abs(r.ms - (to - from)) < 3600e3)
  return { first: inside[0], last: inside[inside.length - 1], days: inside, label: range ? range.label : null }
}

// What the outline is, in words: a preset in lower case ("last 7 days"), a
// date as written ("Oct 6, 2026").
export const selectedText = range => (/^Last /.test(range.label) ? range.label.toLowerCase() : range.label)
